module.exports = __webpack_public_path__ + "static/media/startService.76e45a76.png";